import type { FunctionComponent } from 'react'
import React from 'react'
import { ModalType } from './Modal.types'
import {
  Modal,
  Title,
  Description,
  ButtonContainer,
  StyledButton
} from './ModalRequestErrorHelper.styles'
import { useTranslation } from 'i18n'

interface ModalProps {
  showModal: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dismissModal: () => any
}

const ModalRequestErrorHelper: FunctionComponent<ModalProps> = ({
  showModal,
  dismissModal
}) => {
  const { t } = useTranslation()
  return (
    <Modal
      type={ModalType.NO_HEADER}
      data-testid="request-error-helper-modal"
      show={showModal}
      canCloseByXBtn={false}
      onClose={dismissModal}
    >
      <Title>{t('Alguma coisa inesperada aconteceu.')}</Title>
      <Description>
        {t(
          'Mas vamos te ajudar. Faça contato com nossa equipe pelo botão do chat no canto direito da tela.'
        )}
      </Description>
      <ButtonContainer>
        <StyledButton primary medium onClick={dismissModal}>
          {t('Voltar')}
        </StyledButton>
      </ButtonContainer>
    </Modal>
  )
}

export default ModalRequestErrorHelper
